/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { platformMcpGetOnboarding } from "../funcs/platformMcpGetOnboarding.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { PlatformMCPOnboardingState } from "../models/components/platformmcponboardingstate.js";
import {
  GetPlatformMCPOnboardingRequest,
  GetPlatformMCPOnboardingSecurity,
} from "../models/operations/getplatformmcponboarding.js";
import { unwrapAsync } from "../types/fp.js";
export type PlatformMCPOnboardingQueryData = PlatformMCPOnboardingState;

export function prefetchPlatformMCPOnboarding(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetPlatformMCPOnboardingRequest | undefined,
  security?: GetPlatformMCPOnboardingSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildPlatformMCPOnboardingQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildPlatformMCPOnboardingQuery(
  client$: GramCore,
  request?: GetPlatformMCPOnboardingRequest | undefined,
  security?: GetPlatformMCPOnboardingSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<PlatformMCPOnboardingQueryData>;
} {
  return {
    queryKey: queryKeyPlatformMCPOnboarding({
      gramSession: request?.gramSession,
    }),
    queryFn: async function platformMCPOnboardingQueryFn(
      ctx,
    ): Promise<PlatformMCPOnboardingQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(platformMcpGetOnboarding(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyPlatformMCPOnboarding(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "platformMcp", "getOnboarding", parameters];
}
